// source: https://stackoverflow.com/questions/42812949/suppress-typescript-warnings
export class IsBrowser {
  public static chrome(): boolean {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
}
